import type { ScreenId } from '@/model/state';
/** Route table (SDD §7.4 / §8.1). Stable, bookmarkable paths ↔ the reference's screen ids. */
export const ROUTES: Record<ScreenId, string> = {
  dashboard: '/home',
  widgets: '/home/widgets',
  briefing: '/home/briefing',
  prepare: '/prepare/session',
  riskrules: '/prepare/risk-rules',
  riskprofile: '/prepare/risk-profile',
  strategies: '/prepare/strategies',
  tradehub: '/execute/tradehub',
  signals: '/execute/signals',
  trades: '/execute/trades',
  copytrading: '/execute/copy',
  journal: '/review/journal',
  replay: '/review/replay',
  eod: '/review/eod',
  acctprogress: '/review/progress',
  analytics: '/analyse/analytics',
  compareaccts: '/analyse/compare',
  tradingintel: '/analyse/intelligence',
  perfdigest: '/analyse/digest',
  pfscore: '/analyse/score',
  aiinsights: '/analyse/insights',
  accounts: '/manage/accounts',
  investors: '/manage/investors',
  notifications: '/manage/notifications',
  tradingidentity: '/manage/style',
  billing: '/manage/billing',
  settings: '/manage/settings',
};
export const SCREEN_BY_PATH: Record<string, ScreenId> = Object.fromEntries(
  (Object.entries(ROUTES) as [ScreenId, string][]).map(([id, p]) => [p, id]),
) as Record<string, ScreenId>;
